<template>
  <v-container fluid>
    <v-row dense>
      <!-- ERRORS -->
      <v-col v-if="errors.length" cols="12">
        <v-alert
          v-for="(item, index) in errors"
          :key="index"
          dense
          type="error"
          outlined
          dismissible
          class="mb-2"
        >
          {{ item[0] }}
        </v-alert>
      </v-col>

      <!-- STOCK SELECT -->
      <v-col cols="12">
        <v-autocomplete
          v-model="stockId"
          :items="splrPrdList"
          item-value="stock_id"
          label="Stock Code"
          :loading="splrPrdLoading"
          :search-input.sync="searchInput"
          no-filter
          clearable
          outlined
          dense
          hide-details="auto"
        >
          <template v-slot:selection="{ item }">
            <span class="font-weight-medium">
              {{ item.stock_code }}
            </span>
            <span class="grey--text text-caption ml-2">
              {{ item.product_name }} ({{ item.brand_name }})
            </span>
          </template>

          <template v-slot:item="{ item }">
            <div>
              <div class="primary--text font-weight-medium">
                {{ item.stock_code }}
              </div>
              <div class="text-caption grey--text">
                {{ item.product_name }} ({{ item.brand_name }})
              </div>
            </div>
          </template>
        </v-autocomplete>
      </v-col>

      <!-- PRICE -->
      <v-col cols="12">
        <v-text-field
          v-model.number="retail"
          label="Price"
          type="number"
          :disabled="!stockId"
          outlined
          dense
          hide-details="auto"
          prefix="₱"
        />
      </v-col>

      <!-- QUANTITY -->
      <v-col cols="12">
        <v-text-field
          v-model.number="quantity"
          label="Quantity"
          type="number"
          :disabled="!stockId"
          :suffix="unit ? `/ ${unit}` : ''"
          outlined
          dense
          hide-details="auto"
        />
      </v-col>

      <!-- DISCOUNT (same peso/percent entry as Cash Sales) -->
      <v-col cols="12">
        <div class="d-flex align-center" style="gap: 6px">
          <v-text-field
            v-if="discountMode === 'percent'"
            v-model.number="itemDiscountPercentage"
            class="flex-grow-1"
            label="Discount/Item"
            suffix="%"
            type="number"
            min="0"
            max="100"
            :disabled="!stockId"
            outlined
            dense
            hide-details="auto"
          />
          <v-text-field
            v-else
            v-model.number="itemDiscountFixed"
            class="flex-grow-1"
            label="Discount/Item"
            prefix="₱"
            type="number"
            min="0"
            :disabled="!stockId"
            outlined
            dense
            hide-details="auto"
          />
          <v-btn-toggle v-model="discountMode" mandatory dense>
            <v-btn small value="fixed">
              ₱
            </v-btn>
            <v-btn small value="percent">
              %
            </v-btn>
          </v-btn-toggle>
        </div>
      </v-col>

      <!-- TOTAL DISCOUNT -->
      <v-col cols="12">
        <v-text-field
          v-model.number="discount"
          label="Total Discounted Amnt"
          prefix="₱"
          type="number"
          :disabled="!stockId"
          outlined
          dense
          hide-details="auto"
        />
      </v-col>

      <!-- ADD BUTTON -->
      <v-col cols="12" class="mt-2">
        <v-btn
          block
          color="primary"
          dark
          :loading="verifying"
          :disabled="!stockId || !quantity || !retail"
          @click="addToList"
        >
          <v-icon left>
            mdi-plus
          </v-icon>
          Add to List
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>
<style scoped>
.rounded-lg {
  border-radius: 12px;
}

.v-card {
  transition: 0.2s ease;
}

.v-card:hover {
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
}
</style>
<script>
import { mapState, mapActions } from 'vuex'
import searchDelay from '@/extra-functions/searchDelay.extra'
import { errorHandler } from '@/extra-functions/store.extra'
import consumerLoanInventoryRepository from '@/repositories/consumer-loan-inventory.repository'
import indexKeyGenerator from '@/extra-functions/index-key-generator.extra'
import splrPrdRepository from '@/repositories/supplier-product.repository'
import { apiVars } from '@/extra-functions/api-helper.extra'
import { roundOff } from '@/lib/utils'
const supplierSearchDelay = searchDelay()
const splrPrdDelay = searchDelay()
export default {
  name: 'CreateConsumerLoanInventory',
  props: {
    propConsumerId: String,
    propConsumerLoanId: String,
  },
  data() {
    return {
      ...apiVars('splrPrd'),
      searchingSupplier: false,
      stockId: null,
      retail: null,
      unit: 'none',
      quantity: null,
      verifying: false,
      errors: [],
      searchInput: null,
      // Discount entry mirrors Cash Sales: the per-item figure can be typed as
      // pesos or a percent of the price, and `discount` is the line's total
      discountMode: 'fixed',
      itemDiscountPercentage: null,
      itemDiscountFixed: null,
      discount: null,
    }
  },
  created() {
    this.getSplrPrd()
    // this.fetchSuppliers({ index: 0, count: 10, search: '' })
  },
  computed: {
    ...mapState({
      storeId: (state) => state.settings.storeId,
      suppliers: (state) => state.supplier.list,
      fetchingSupplier: (state) => state.supplier.fetching,
      // supplierProducts: state => state.supplierProduct.list,
      supplierProductFetching: (state) => state.supplierProduct.fetching,
      supplierProductUpdate: (state) => state.supplierProduct.channelUpdate,
    }),
    // computedSupplierProducts () {
    //   return this.splrPrdList.map(this.computeSupplierProduct)
    // },
    cost() {
      return this.selectedStock.cost || 0
    },
    selectedStock() {
      return this.splrPrdList.find((e) => e.stock_id === this.stockId)
    },
    supplierId() {
      const supplierPrd = this.splrPrdList.find(
        (item) => item.stock_id === this.stockId,
      )
      return supplierPrd.supplier_id
    },
  },
  watch: {
    searchInput(val) {
      if (!val && val !== undefined) return
      this.getSplrPrd()
    },
    // supplierId (supplierId) {
    //   this.getSplrPrd()
    //   // this.fetchSupplierProducts(supplierId)
    // },
    selectedStock(obj) {
      if (!obj) return
      this.retail = obj.retail
      this.unit = obj.unit
    },
    // Watchers rather than @keyup so the total also follows the number
    // spinners, paste, and a price change from picking a different stock
    quantity() {
      this.recalculateDiscount()
    },
    retail() {
      this.recalculateDiscount()
    },
    itemDiscountFixed() {
      if (this.discountMode !== 'fixed') return
      this.onItemDiscountFixedChange()
    },
    itemDiscountPercentage() {
      if (this.discountMode !== 'percent') return
      this.onItemDiscountPercentageChange()
    },
    discountMode() {
      this.recalculateDiscount()
    },
    supplierProductUpdate() {
      this.getSplrPrd()
      // this.fetchSupplierProducts(this.supplierId)
    },
  },
  methods: {
    ...mapActions({
      fetchSuppliers: 'supplier/fetch',
      fetchSupplierProducts: 'supplierProduct/fetch',
      addConsumerLoanInventory: 'consumerLoanInventory/addToTempList',
    }),
    getSplrPrd() {
      // if (!this.splrPrdLoading) {
      this.splrPrdLoading = true
      this.splrPrdErrors = []
      splrPrdDelay(() => {
        splrPrdRepository
          .paginate(this.storeId, { search: this.searchInput })
          .then(({ data }) => {
            this.splrPrdList = data
          })
          .catch((e) => {
            this.splrPrdErrors = errorHandler(e)
          })
          .then(() => {
            this.splrPrdLoading = false
          })
      })
      // }
    },
    // Percent and peso stay in step with each other and with the line total,
    // exactly as they do on the Cash Sales form
    // Single source of truth: these read the model values only. Reading
    // e.target.value from @keyup as well meant two paths wrote `discount`,
    // and a type="number" input reports "" for a half-typed decimal.
    onItemDiscountPercentageChange() {
      const percent = Number(this.itemDiscountPercentage) || 0
      const retail = Number(this.retail) || 0
      const quantity = Number(this.quantity) || 0
      this.discount = roundOff((percent / 100) * retail * quantity)
      this.itemDiscountFixed = roundOff((percent / 100) * retail)
    },
    onItemDiscountFixedChange() {
      const perItem = Number(this.itemDiscountFixed) || 0
      const retail = Number(this.retail) || 0
      const quantity = Number(this.quantity) || 0
      this.discount = roundOff(perItem * quantity)
      this.itemDiscountPercentage = retail
        ? Math.round((perItem / retail) * 1000) / 10
        : null
    },
    // Price or quantity moved, so the line total has to follow
    recalculateDiscount() {
      if (this.discountMode === 'fixed') {
        this.onItemDiscountFixedChange()
      } else {
        this.onItemDiscountPercentageChange()
      }
    },
    clearDiscount() {
      this.itemDiscountPercentage = null
      this.itemDiscountFixed = null
      this.discount = null
    },
    addToList() {
      if (!this.verifying) {
        this.verifying = true
        this.errors = []
        const data = {
          id: indexKeyGenerator(),
          consumer_loan_id: this.propConsumerLoanId,
          supplier_id: this.supplierId,
          stock_id: this.stockId,
          unit: this.unit,
          retail: this.retail,
          quantity: this.quantity,
          cost: this.cost,
          discount: this.discount || 0,
        }
        const extraData = {
          stock_code: this.selectedStock.stock_code,
          product_name: this.selectedStock.product_name,
        }
        const params = {
          consumer: this.propConsumerId,
          consumerLoan: this.propConsumerLoanId,
        }
        consumerLoanInventoryRepository
          .verify(params, data)
          .then(this.verifySuccess(extraData).bind(this))
          .catch((e) => {
            this.errors = errorHandler(e)
          })
          .then(() => {
            this.verifying = false
          })
      }
    },
    funcSearchSupplier() {
      this.searchingSupplier = true
      supplierSearchDelay(() => {
        this.searchingSupplier = false
        this.fetchSuppliers({ index: 0, count: 10, search: this.searchInput })
      })
    },
    verifySuccess(exData) {
      return function ({ data }) {
        this.addConsumerLoanInventory({
          ...data,
          ...exData,
        })
        // The next item starts at no discount rather than inheriting this one
        this.clearDiscount()
      }
    },
    // computeSupplierProduct (e) {
    //   const stock = e.stock
    //   const unit = stock.unit
    //   const sales = !e.sale_inventory.length ? 0 : e.sale_inventory[0].quantity
    //   const lost = !e.lost_inventory.length ? 0 : e.lost_inventory[0].quantity
    //   const recieved = !e.recieved_inventory.length ? 0 : e.recieved_inventory[0].quantity
    //   const loan = !e.consumer_loan_inventory.length ? 0 : e.consumer_loan_inventory[0].quantity
    //   return {
    //     ...e,
    //     unitDesc: unit.description,
    //     productName: stock.product_name,
    //     brandName: stock.brand_name,
    //     quantity: this.quantity,
    //     date_sold: this.dateTransaction,
    //     qRemaining: recieved - (sales + lost + loan),
    //   }
    // },
  },
}
</script>
